"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const ProgressBar_styled_1 = require("./ProgressBar.styled");
function ProgressBar({ progress, label, displayAmount }) {
    const theme = (0, react_1.useContext)(styled_components_1.ThemeContext) || malty_theme_malty_theme_provider_1.globalTheme;
    return (react_1.default.createElement(ProgressBar_styled_1.StyledWrapper, { theme: theme },
        react_1.default.createElement(ProgressBar_styled_1.StyledBarContainer, { theme: theme },
            react_1.default.createElement(ProgressBar_styled_1.StyledProgressBar, { progress: progress, theme: theme }),
            displayAmount && react_1.default.createElement(ProgressBar_styled_1.StyledProgressAmount, { theme: theme },
                progress,
                "%")),
        label && react_1.default.createElement(ProgressBar_styled_1.StyledText, { theme: theme }, label)));
}
exports.ProgressBar = ProgressBar;
//# sourceMappingURL=ProgressBar.js.map